import { useTranslation } from 'react-i18next';
import type { NotificationResponse } from '@monorepo/notification-common';

export const useTranslateNotification = () => {
  const { t } = useTranslation('notification');

  const translate = (notification: NotificationResponse) => {
    const result = t(notification.type, {
      ...notification.values,
    });

    return result;
  };

  return { translate };
};
